import React from 'react';
import styles from '../../components/FormattedPrice/FormattedPrice.module.scss';

export type FormattedPriceProps = {
  className?: string;
  classNamePounds?: string;
  price: number;
  originalPrice?: number;
};

export const FormattedPrice: React.FC<FormattedPriceProps> = ({ className, classNamePounds, price, originalPrice }) => (
  <span className={`${styles.price} ${className}`}>
    {originalPrice && (
      <>
        <span className={styles.price__cut}>&pound;{(originalPrice / 100).toFixed(2)}</span>
        {' / '}
      </>
    )}
    &pound;<span className={`${styles.price__pounds} ${classNamePounds}`}>{Math.floor(price / 100)}</span>.
    {((price / 100) % 1).toFixed(2).substring(2)}
  </span>
);
